import React from 'react';
import createRosettaContainer from './createRosettaContainer';
import ArchivesInterface from '../components/archives/archives_interface';
import ArchivesFooterNav from '../components/archives/archives_footer_nav';
import { getArchivesState } from '../utils/date';

const options = {
  displayName: 'ArchivesContainer',

  UNSAFE_componentWillMount() {

    this.setArchivesState(this.props.location.pathname);
  },

  UNSAFE_UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname === this.props.location.pathname) {
      return;
    }
    this.setArchivesState(nextProps.location.pathname);
  },

  setArchivesState(pathname) {
    this.setState({
      archives: getArchivesState(pathname)
    });
  },

  contentAboveModules() {
    return (
      <ArchivesInterface {...this.state.archives}
        resultsCount={this.props.analytics.result_count}
      />
    );
  },

  contentBelowModules() {
    return (
      <ArchivesFooterNav {...this.state.archives} />
    );
  }
};

export const ArchivesContainer = createRosettaContainer({
  ...options,
  shouldDecorateContainer: false
});

export default createRosettaContainer(options);
